import styled from "styled-components";

export const NavigationBar = styled.nav`
  width: 100vw;
  bottom: 0;
  height: 70px;
  display: flex;
  position: fixed;
  box-shadow: ${(props) => props.theme.shadows.navBar};
  background: ${(props) => props.theme.colors.white100};
  align-items: center;
  justify-content: center;
`;
